import React from "react";

const ImageFileInput = ({
  id = "fileInput",
  accept = "image/*",
  className,
  hidden = true,
  disabled = false,
  onChange,
}) => {
  return (
    <input
      id={id}
      type="file"
      accept={accept}
      className={className}
      onChange={onChange}
      hidden={hidden}
      disabled={disabled}
    />
  );
};

export default ImageFileInput;


